import { useEffect, useState } from "react";

export default function CopyLinkButton({ t, copy }) {
  const [copied, setCopied] = useState(false);

  useEffect(() => {
    if (!copied) {
      return undefined;
    }

    const timer = window.setTimeout(() => setCopied(false), 1800);
    return () => window.clearTimeout(timer);
  }, [copied]);

  async function copyCurrentUrl() {
    const url = window.location.href;

    try {
      if (navigator.clipboard?.writeText) {
        await navigator.clipboard.writeText(url);
      } else {
        copyWithFallback(url);
      }

      setCopied(true);
    } catch {
      copyWithFallback(url);
      setCopied(true);
    }
  }

  return (
    <button
      type="button"
      onClick={copyCurrentUrl}
      style={buttonStyle(t, copied)}
      aria-live="polite"
    >
      {copied ? copy.linkCopied : copy.copyLink}
    </button>
  );
}

function copyWithFallback(value) {
  const textarea = document.createElement("textarea");
  textarea.value = value;
  textarea.setAttribute("readonly", "");
  textarea.style.left = "-9999px";
  textarea.style.position = "fixed";
  document.body.appendChild(textarea);
  textarea.select();
  document.execCommand("copy");
  document.body.removeChild(textarea);
}

function buttonStyle(t, copied) {
  return {
    background: "transparent",
    border: 0,
    color: copied ? t.link : t.dim,
    cursor: "pointer",
    fontFamily: "'JetBrains Mono', monospace",
    fontSize: 12,
    padding: 0,
  };
}
